import { render, staticRenderFns } from "./EndOfYearGiving.vue?vue&type=template&id=9006e33a&"
import script from "./EndOfYearGiving.vue?vue&type=script&lang=js&"
export * from "./EndOfYearGiving.vue?vue&type=script&lang=js&"
import style0 from "./EndOfYearGiving.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports